module.exports = __webpack_public_path__ + "img/9788967355654.00b23e94.jpg";